import React from 'react';

export default function IE11Warning() {
  return (
    <div className="IE11Warning">
    <p>Please upgrade your browser</p>
    To get the best possible experience using our site, we recommend that you upgrade to Microsoft edge or choose another web browser as Internet Explorer 11 is retiring as of June 15, 2022.
    </div>
  );
}